
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Beleg from '@/types/Beleg';
    import { CompareFunction, DataTableHeaders } from '@/types';
    import Impfstelle from '@/types/Impfstelle';
    import RechnungseingangDialog from '@/components/Rechnungseingang/RechnungseingangDialog.vue';
    import moment from 'moment';

    @Component({
        components: {
            RechnungseingangDialog,
            EingetragenAmVom,
        },
        computed: {
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('globals', ['sortDate']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('kassafuehrung', ['offeneZahlscheinBelege', 'loaders', 'dialogs', 'beleg']),
            ...mapState('authentication', ['impfstelle']),

        },
        methods: {
            ...mapActions('kassafuehrung', ['loadOffeneZahlscheinBelege']),
            ...mapMutations('kassafuehrung', ['setDialogZahlungseingang', 'setBeleg']),
            ...mapActions('authentication', ['loadImpfstelle']),

        },
    })
    export default class Zahlungseingang extends Vue {
        public sortDate!: CompareFunction<Beleg>;
        public loadOffeneZahlscheinBelege!: () => void;
        public setBeleg!: (payload: { beleg: Beleg, load: boolean }) => void;
        public setDialogZahlungseingang!: (payload: { zahlungseingang?: boolean}) => void;
        public offeneZahlscheinBelege!: Beleg[];
        public impfstelleDetail!: Impfstelle;
        public impfstelle_id!: number;
        public beleg: any;
        public loadImpfstelle!: () => void;
        public impfstelle!: Impfstelle;

        public get headers(): DataTableHeaders<Beleg> {
            return [
                { value: 'belegnr', text: 'Beleg Nr.', width: 250, align: 'center'},
                { value: 'datum', text: 'Datum', sort: this.sortDate, width: 150 },
                { value: 'belegempfaenger', text: 'Belegempfänger', width: 400 },
                { value: 'gesamtbetrag', text: 'Rechnungsbetrag'},
                { value: 'zahlungsziel', text: 'Zahlungziel'},
                { value: 'gemahnt', text: 'Gemahnt am'},
                { value: 'actions', text: '', sortable: false, width: 50 },
            ];
        }

        public mounted(): void {
            this.loadOffeneZahlscheinBelege();
            this.loadImpfstelle();
        }

        protected belegeSum = (sum: number, beleg: Beleg): number => {
            return sum += (!beleg.isStorniert ? beleg.gesamtbetrag ?? 0 : 0);
        };

        public summe(belege: Beleg[]): number {
            return belege.reduce(this.belegeSum, 0);
        }

        public openRechnung(item: Beleg) {
            this.setDialogZahlungseingang({ zahlungseingang: true });
            this.setBeleg({beleg: item, load: true});
        }

        public getZahlungsziel(item: string): string | any {
            var zahlungziel = moment(item).add(this.impfstelle.zahlungsziel_tage, 'days').format('YYYY-MM-DD');
            return this.$d(zahlungziel);
        }
    }
